import script from "./WhatsAppConfigPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppConfigPage.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppConfigPage.vue?vue&type=style&index=0&id=73e20940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e20940"]])

export default __exports__